import { initContract } from '@ts-rest/core';
import { adminModerationContract } from './moderation.admin.contract';

const c = initContract();

export const moderationContract = c.router(
	{
		admin: adminModerationContract,
	},
	{
		pathPrefix: '/moderation',
		strictStatusCodes: true,
	}
);

export * from './models';
export * from './moderation.admin.contract';

